export default __webpack_public_path__ + "static/media/trezor.655aee31.svg";